import { locationRedirectFunction } from "./location-redirectFunc";
import { wwwInjectionFunction } from "./www-injectionFunc";

export default async function ({
  req,
  redirect,
  app: { $cookies, i18n },
  route,
}) {
  if (!process.server) return;

  let redirectUrl = req.url;

  let locationRedirect = await locationRedirectFunction({
    req,
    app: { $cookies, i18n },
    url: redirectUrl,
    route,
  });
  if (locationRedirect) {
    redirectUrl = locationRedirect;
  }

  let wwwInjection = wwwInjectionFunction({
    req,
    i18n,
    $cookies,
    urlString: redirectUrl,
  });
  if (wwwInjection) {
    redirectUrl = wwwInjection;
  }

  // Check if the current route is the homepage and does not have a trailing slash
  const isHomePageWithoutTrailingSlash = route.name === null;

  redirectUrl =
    redirectUrl.endsWith("/") || redirectUrl.includes("?")
      ? redirectUrl
      : isHomePageWithoutTrailingSlash
      ? `${redirectUrl}/`
      : redirectUrl;
      
  if (redirectUrl !== req.url) {
    await redirect(redirectUrl);
  }
}
